import { createSlice } from "@reduxjs/toolkit";
import apiManagerSubtitles from "api/manager-subtitles";
import moment from "moment";
import { setShowBackdrop } from "store/commonSlice";
import store from "store/store";

export const fetchData = async (data) => {
    try {
        store.dispatch(setShowBackdrop(true))
        const res = await apiManagerSubtitles.getListSub(data)
        if (res?.records) {
            store.dispatch(setTableData({
                data: res?.records,
                total: res?.total
            }))
            store.dispatch(setIsLoading(false))
        }

    } catch (err) {
        store.dispatch(setIsLoading(false))
    } finally {
        store.dispatch(setShowBackdrop(false))
    }
}

const initialState = {
    tableData: {
        data: [],
        total: 0
    },
    tableDataShare: {
        data: [],
        total: 0,
    },
    searchQuery: {
        startDate: moment().subtract(30, 'days').unix(),
        endDate: moment().unix(),
        is_sub_moved_to_trash: 0,
        is_my_sub: 1,
        is_sub_share_with_me: 1,
        room_name: '',
        page: 1
    },
    backPage: false,
    queryParamsHeader: {},
    roomDetail: {
        roomName: '',
        id: '',
        startTime: ''
    },
    idIsEditing: '',
    isRefresh: false,
    isLoading: false
}

export const managerSubsSlice = createSlice({
    name: 'managerSubs',
    initialState,
    reducers: {
        setTableData: (state, action) => {
            state.tableData = action.payload
        },
        setSearchQuery: (state, action) => void (state.searchQuery = action.payload),
        setTableDataShare: (state, action) => void(state.tableDataShare = action.payload),
        setSearchQueryShare: (state, action) => void (state.searchQueryShare = action.payload),
        toggleIsRefresh: (state) => void (state.isRefresh = !state.isRefresh),
        setIsLoading: (state, action) => void (state.isLoading = action.payload),
        setIdIsEditing: (state, action) => void(state.idIsEditing = action.payload),
        setBoardSharing: (state, action) => void(state.boardSharing = action.payload),
        setQueryParamsHeader: (state, action) => void(state.queryParamsHeader = action.payload),
        setRoomDetail: (state, action) => void(state.roomDetail = action.payload),
        setBackPage: (state, action) => void(state.backPage = action.payload)
    }
})

export const { setTableData, setSearchQuery, setTableDataShare, setSearchQueryShare,toggleIsRefresh, setIdIsEditing, setBoardSharing, setQueryParamsHeader, setIsLoading, setRoomDetail, setBackPage} = managerSubsSlice.actions
export default managerSubsSlice.reducer
